import {Loader2} from "lucide-react";

import {Button, type ButtonProps} from "@/components/ui/button";
import {cn} from "@/lib/utils";
import {prewarmCoordinatesForGate} from "@/src/modules/core/hooks/use-coordinates-gate";

type ComplianceGateActionButtonProps = ButtonProps & {
  /** True while this specific action's mutation is in flight. */
  isLoading?: boolean;
  /** Disable because another action in the same gate is running. */
  isOtherLoading?: boolean;
  /** Optional label shown while loading (defaults to children). */
  loadingLabel?: React.ReactNode;
  /** Start GPS acquisition on press before click (default: true). */
  prewarmCoordinates?: boolean;
};

export function ComplianceGateActionButton({
  isLoading = false,
  isOtherLoading = false,
  loadingLabel,
  prewarmCoordinates = true,
  disabled,
  className,
  children,
  onPointerDown,
  ...props
}: ComplianceGateActionButtonProps) {
  return (
    <Button
      {...props}
      onPointerDown={(event) => {
        if (prewarmCoordinates) {
          prewarmCoordinatesForGate();
        }
        onPointerDown?.(event);
      }}
      className={cn(isLoading && "gap-2", className)}
      aria-busy={isLoading || undefined}
      disabled={disabled || isLoading || isOtherLoading}
    >
      {isLoading ? <Loader2 className="size-4 animate-spin" /> : null}
      {isLoading && loadingLabel ? loadingLabel : children}
    </Button>
  );
}
